import { useEffect, useState } from "react";
import isObject from "lodash/isObject";
import { useFormikContext } from "formik";

// Get first error in Formik Error array
const getFirstErrorKey = (object, keys = []) => {
    const firstErrorKey = Object.keys(object)[0];
    if (isObject(object[firstErrorKey])) {
        return getFirstErrorKey(object[firstErrorKey], [
            ...keys,
            firstErrorKey,
        ]);
    }

    // console.log(firstErrorKey)
    return [...keys, firstErrorKey].join(".");
};

export const FormikOnError = ({ children }) => {
    const formik = useFormikContext();
    const [submitCount, setSubmitCount] = useState(formik.submitCount);

    useEffect(() => {
        // IF formik submit count > stored submit count,
        // Get the first error and scroll to it
        // console.log(formik.errors);
        if (!formik.isValid && formik.submitCount > submitCount) {
            const firstErrorKey = getFirstErrorKey(formik.errors);
            if (
                global.window.document.getElementsByName(firstErrorKey).length
            ) {
                global.window.document
                    .getElementsByName(firstErrorKey)[0]
                    .focus();
            }
            setSubmitCount(formik.submitCount);
        }
    }, [formik.submitCount, submitCount, formik.isValid, formik.errors]);
    return children;
};
